import {BaseService, QueryParams} from '../../../../core/abstracts/base-service.abstract';
import {Pageable} from '../../../../core/interfaces/base-service.interfaces';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {OwnerResponse} from '../models/owner-response.model';
import {PageableRequest} from '../../../../core/models/pagable.model';
import {PageableResponse} from '../../../../core/models/page-response.model';
import {OwnerSearchFilterRequest} from '../models/owner-search-filter-request.model';

@Injectable({providedIn: 'root'})
export class VehicleOwnerService extends BaseService implements Pageable<OwnerResponse> {
  protected readonly endpoint: string = 'owners';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  getPage(
    pageable: PageableRequest,
    filters?: OwnerSearchFilterRequest
  ): Observable<PageableResponse<OwnerResponse>> {

    const params: QueryParams = {
      page: pageable.page,
      size: pageable.size,
      sort: pageable.sort,
      ...filters
    };

    return this.get<PageableResponse<OwnerResponse>>('', params);
  }
}
